// removed by extract-text-webpack-plugin
module.exports = {"title":"qempo_Benefits_title-27oGyDP","benefits":"qempo_Benefits_benefits-3t9jejO","benefit":"qempo_Benefits_benefit-1W6XS7n","middle":"qempo_Benefits_middle-2bI5Db9","imgWrap":"qempo_Benefits_imgWrap-fuf3KlI","benefitsVariantWrap":"qempo_Benefits_benefitsVariantWrap-2PMlbeM","benefitsVariant":"qempo_Benefits_benefitsVariant-4cJYl8e","dummyWrap":"qempo_Benefits_dummyWrap-1SmrL-9","arrowLeft":"qempo_Benefits_arrowLeft-2W7kSrA","arrowRight":"qempo_Benefits_arrowRight-3VrrMfK"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/HomeLanding/Benefits/Benefits.scss
// module id = 2019
// module chunks = 0